import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { MasterConstants } from '../../../common/constants/master-constants';
import { DashboardFilter } from '../../../models/DashboardFilter';
import { UserSecurityService } from '../../../services/common/user-security.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { BroadcastService } from '../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../services/infrastructure/config.service';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
const _ = require('lodash');
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-crop-edge-account-list-dialog',
  templateUrl: './crop-edge-account-dialog.component.html',
  styleUrls: ['./crop-edge-account-dialog.component.scss']
})

export class CropEdgeAccountListDialogComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();

  districtList: any = [];
  filterArray = [];
  attachedAccountsList: any[];
  attachedUserList: any[];
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  emulatedUserIdText: string;
  loggedInUserText: string;
  validateEvolveData: any;
  selectedDistrict: any;
  isSetEmulation = false;
  userToEmulateText: string;
  userEmulationSubscription: any;
  getAttachedAccountListSubscription: any;
  getUserIdListSubscription: any;
  setEmulationSubscription: any;
  clearEmulationSubscription: any;
  getDistrictFilterSubscription: any;
  cleanAccount = false;
  constructor(private userSecurityService: UserSecurityService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private dialogRef: MatDialogRef<CropEdgeAccountListDialogComponent>
  ) { }

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      let selectedCom;
      if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
        selectedCom = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
      }

      const activeUser = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (this.validateEvolveData != null && this.headerYear != undefined &&
        this.headerCompany != undefined && activeUser) {
        if (activeUser.isEmulationSet) {
          this.loggedInUserText = activeUser.loggedUserId.toUpperCase() + ' - ' + activeUser.loggedUserName.toUpperCase();
          this.userToEmulateText = '';
          this.emulatedUserIdText = activeUser.userId.toUpperCase() + ' - ' + activeUser.firstName.toUpperCase();
          this.isSetEmulation = true;
        }
        else {
          this.isSetEmulation = false;
          this.loggedInUserText = activeUser.userId.toUpperCase() + ' - ' + activeUser.firstName.toUpperCase() + ' ' + activeUser.lastName.toUpperCase();
          this.emulatedUserIdText = '';
        }
      }
    }
  }

  // ngOnInit
  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    this.clearUserText();
    this.setEvolveAccessData();

    this.subscription.push(this.broadcastService.on<any>(this.configService.SET_USER_EMULATION).subscribe((data) => {
      this.setEvolveAccessData();
      this.selectedDistrict = new Number();
    }));
  }

  // Set Name and user id
  setEvolveAccessData() {
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      const activeUser = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      if (activeUser) {
        if (activeUser.evolveAccountRestriction) {
          this.filterArray = [
            // { label: 'Account Name', column: 'accountName' },
            { label: 'City', column: 'city' },
            { label: 'Account Number', column: 'account' },
            { label: 'State / Province', column: 'state' }];
        }
        else {
          this.filterArray = [
            { label: 'City', column: 'city' },
            { label: 'Account Number', column: 'accounttxt' },
            { label: 'Account Name', column: 'accountName' },
            { label: 'State / Province', column: 'state' }];
        }
      }
    }
  }

  // Clear user text
  clearUserText() {
    this.attachedAccountsList = [];
    this.attachedUserList = [];
    this.emulatedUserIdText = '';
    this.userToEmulateText = '';
    this.isSetEmulation = false;
    this.selectedDistrict = new Number();
  }

  // Filter Grid
  filterGrid(e: any) {
    if (e == null) {
      this.attachedAccountsList = [];
      this.attachedUserList = [];
      this.districtList = [];
      if (!this.cleanAccount) {
        this.userToEmulateText = '';
      }
      return false;
    }

    if (e != null &&
      e.account == null &&
      e.accountName == null &&
      e.state == null &&
      e.city == null) {
      this.attachedAccountsList = [];
      this.attachedUserList = [];
      return false;
    }

    if (e != null) {
      this.subscription.push(this.userSecurityService.getCropEdgeAccountList(e).subscribe(results => {
        if (results) {
          this.attachedAccountsList = results as any[];
        }
      }, error => {
        LolLoggerService.error(error);
      }));
    }

    if (this.cleanAccount) {
      this.cleanAccount = false;
    }
  }

  // Account click operation
  accountClick(crossRefValue) {
    this.subscription.push(this.userSecurityService.getCropEdgePartnerWebsite(crossRefValue).subscribe(result => {
      if (result.nkUrl != '') {
        window.open(result.nkUrl, '_blank');
        this.dialogRef.close();
      }
      else {
        this.toastrService.error('Url not found for the selected account.');
      }
    }, (error => {
      LolLoggerService.error(error);
    })));
  }

  closeDialog() {
    this.dialogRef.close();
  }

  // ngOnDestroy
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
